export const getValidationMessage = (
  field = '',
  locale,
  error,
  additionalProps = {},
) => {
  const translations = {
    'en-US': {
      // Error Templates
      required: '$fieldName is required',
      invalid: '$fieldName is invalid',
      invalidFormat: `$fieldName is in an invalid format ${
        additionalProps.format ? additionalProps.format : ''
      }`,
      maxLength: `$fieldName exceeds max character length  ${
        additionalProps.maxLength ? additionalProps.maxLength : ''
      }`,
      minLength: `$fieldName does not meet minimum character length  ${
        additionalProps.minLength ? additionalProps.minLength : ''
      }`,
      minLengthName: `'$fieldName' requires a minimum of two characters`,
      patternName: `'$fieldName' contains invalid characters`,
      maxAge: `Please enter a date of birth in this format: ${
        additionalProps.format ? additionalProps.format : ''
      }`,
      minAge: `Sorry, you need to be at least ${
        additionalProps.minAge ? additionalProps.minAge : ''
      } to register an account.`,
      pattern: `$fieldName does not match pattern ${
        additionalProps.pattern ? additionalProps.pattern : ''
      }`,
      dataRuleValueInvalidDate: 'Please enter a valid date',
      regExPatternNoMatch: '$fieldName did not match pattern',
      dataRuleNumeric: '$fieldName must be numeric',
      paymentFormSecurityCodeInvalid:
        'Invalid CVV for your selected card type.',
      creditCardExpiredError: 'The credit card has expired',
      invalidEmail:
        'Sorry, that email address doesn’t look right. Please check the email and try again.',
      // Field Names
      title: 'Title',
      firstName: `First Name`,
      lastName: `Last Name`,
      dateOfBirth: 'Birth date',
      country: 'Country of Residence',
      emailAddress: 'Email Address',
      password: 'Password',
      recieveLatestNews: '',
      confirmationTC: '',
      deviceName: 'Device Name',
      nameOnCard: 'Name on card',
      securityCode: 'Security code',
      addressLineOne: 'Address line 1',
      city: 'City',
      state: 'State',
      region: 'Region',
      province: 'Province',
      postalCode: 'Postal code',
      zipCode: 'Zip code',
      cardNumber: 'Card number',
    },
    'en-GB': {
      // Error Templates
      required: '$fieldName is required',
      invalid: '$fieldName is invalid',
      invalidFormat: `$fieldName is in an invalid format ${
        additionalProps.format ? additionalProps.format : ''
      }`,
      maxLength: `$fieldName exceeds max character length  ${
        additionalProps.maxLength ? additionalProps.maxLength : ''
      }`,
      minLength: `$fieldName does not meet minimum character length  ${
        additionalProps.minLength ? additionalProps.minLength : ''
      }`,
      minLengthName: `'$fieldName' requires a minimum of two characters`,
      patternName: `'$fieldName' contains invalid characters`,
      maxAge: `Please enter a date of birth in this format: ${
        additionalProps.format ? additionalProps.format : ''
      }`,
      minAge: `Sorry, you need to be at least ${
        additionalProps.minAge ? additionalProps.minAge : ''
      } to register an account.`,
      pattern: `$fieldName does not match pattern ${
        additionalProps.pattern ? additionalProps.pattern : ''
      }`,
      dataRuleValueInvalidDate: 'Please enter a valid date',
      regExPatternNoMatch: '$fieldName did not match pattern',
      dataRuleNumeric: '$fieldName must be numeric',
      paymentFormSecurityCodeInvalid:
        'Invalid CVV for your selected card type.',
      creditCardExpiredError: 'The credit card has expired',
      invalidEmail:
        'Sorry, that email address doesn’t look right. Please check the email and try again.',
      // Field Names
      title: 'Title',
      firstName: `First Name`,
      lastName: `Last Name`,
      dateOfBirth: 'Birth date',
      country: 'Country of Residence',
      emailAddress: 'Email Address',
      password: 'Password',
      recieveLatestNews: '',
      confirmationTC: '',
      deviceName: 'Device Name',
      nameOnCard: 'Name on card',
      securityCode: 'Security code',
      addressLineOne: 'Address line 1',
      city: 'City',
      state: 'State',
      region: 'Region',
      province: 'Province',
      postalCode: 'Postal code',
      zipCode: 'Zip code',
      cardNumber: 'Card number',
    },
    'fr-FR': {
      // Error Templates
      required: '$fieldName est requis(e)',
      invalid: '$fieldName est invalide',
      invalidFormat: `$fieldName est invalide ${
        additionalProps.format ? additionalProps.format : ''
      }`,
      maxLength: `$fieldName a une longueur maximale de ${
        additionalProps.maxLength ? additionalProps.maxLength : ''
      }`,
      minLength: `$fieldName does not meet minimum character length  ${
        additionalProps.minLength ? additionalProps.minLength : ''
      }`,
      minLengthName: `Au minimum deux caractères sont requis pour le « $fieldName »`,
      patternName: `Le « $fieldName » contient des caractères invalides`,
      maxAge: `Veuillez saisir une date de naissance en utilisant ce format: ${
        additionalProps.format ? additionalProps.format : ''
      }`,
      minAge: `Désolé, vous devez être âgé au moins de ${
        additionalProps.minAge ? additionalProps.minAge : ''
      } ans pour créer un compte.`,
      pattern: `$fieldName n'est pas valide ${
        additionalProps.pattern ? additionalProps.pattern : ''
      }`,
      dataRuleValueInvalidDate: 'Veuillez saisir une date valide',
      regExPatternNoMatch: "$fieldName n'est pas valide",
      dataRuleNumeric: '$fieldName doit comporter des chiffres',
      paymentFormSecurityCodeInvalid:
        'Cryptogramme invalide pour le type de carte sélectionné.',
      creditCardExpiredError:
        'Carte expirée. Merci de mettre les informations à jour.',
      invalidEmail:
        "Désolé, cette adresse e-mail ne semble pas correcte. Veuillez vérifier l'email et réessayer.",
      // Field Names
      title: 'Titre',
      firstName: 'Prénom',
      lastName: 'Nom',
      dateOfBirth: 'Date de naissance',
      country: 'Pays de résidence',
      emailAddress: 'E-mail',
      password: 'Mot de passe',
      recieveLatestNews: '',
      confirmationTC: '',
      deviceName: 'Surnom',
      nameOnCard: 'Nom sur la carte',
      securityCode: 'Code de sécurité',
      addressLineOne: 'Adresse de facturation',
      city: 'Ville',
      state: 'État',
      region: 'Région',
      province: 'Région/Province',
      postalCode: 'Code postal',
      zipCode: 'Code ZIP',
      cardNumber: 'Numéro de carte',
    },
    'es-MX': {
      // Error Templates
      required: '$fieldName es requerido',
      invalid: '$fieldName no es válida',
      invalidFormat: `$fieldName no es válida ${
        additionalProps.format ? additionalProps.format : ''
      }`,
      maxLength: `$fieldName tiene una longitud máx. de ${
        additionalProps.maxLength ? additionalProps.maxLength : ''
      }`,
      minLength: `$fieldName does not meet minimum character length  ${
        additionalProps.minLength ? additionalProps.minLength : ''
      }`,
      minLengthName: `'$fieldName' requiere un mínimo de dos caracteres`,
      patternName: `'$fieldName' contiene caracteres no válidos`,
      maxAge: `Por favor, introduce una fecha de nacimiento con este formato: ${
        additionalProps.format ? additionalProps.format : ''
      }`,
      minAge: `Perdona, necesitas tener al menos ${
        additionalProps.minAge ? additionalProps.minAge : ''
      } años para registrar una cuenta.`,
      pattern: `$fieldName no es válido ${
        additionalProps.pattern ? additionalProps.pattern : ''
      }`,
      dataRuleValueInvalidDate: 'Por favor, introduce una fecha válida',
      regExPatternNoMatch: '$fieldName no es válido',
      dataRuleNumeric: '$fieldName debe ser numérico',
      paymentFormSecurityCodeInvalid:
        'CVV no válido para el tipo de tarjeta seleccionado.',
      creditCardExpiredError: 'La tarjeta de crédito ha caducado',
      invalidEmail:
        'Lo siento, la dirección de correo electrónico no parece correcta. Por favor, compruebe el correo electrónico y vuelva a intentarlo.',
      // Field Names
      title: 'Título',
      firstName: 'Nombre',
      lastName: 'Apellido',
      dateOfBirth: 'Fecha de nacimiento',
      country: 'País de residencia',
      emailAddress: 'Email',
      password: 'Contraseña',
      recieveLatestNews: '',
      confirmationTC: '',
      deviceName: 'Nick',
      nameOnCard: 'Nombre en la tarjeta',
      securityCode: 'Código de seguridad',
      addressLineOne: 'Línea de dirección de correo 1',
      city: 'Localidad',
      state: 'Estado',
      region: 'Comunidad Autónoma',
      province: 'Provincia',
      postalCode: 'Código postal',
      zipCode: 'Código postal',
      cardNumber: 'Número de tarjeta',
    },
    'de-DE': {
      // Error Templates
      required: '$fieldName ist erforderlich',
      invalid: '$fieldName ist ungültig',
      invalidFormat: `$fieldName ist ungültig ${
        additionalProps.format ? additionalProps.format : ''
      }`,
      maxLength: `$fieldName hat eine maximale Länge von ${
        additionalProps.maxLength ? additionalProps.maxLength : ''
      }`,
      minLength: `$fieldName does not meet minimum character length  ${
        additionalProps.minLength ? additionalProps.minLength : ''
      }`,
      minLengthName: '„$fieldName“ muss mindestens zwei Zeichen lang sein',
      patternName: '„$fieldName“ enthält ungültige Zeichen',
      maxAge: `Bitte Geburtsdatum im folgenden Format eingeben: ${
        additionalProps.format ? additionalProps.format : ''
      }`,
      minAge: `Das Mindestalter für das Anlegen eines Kontos ist ${
        additionalProps.minAge ? additionalProps.minAge : ''
      } Jahre.`,
      pattern: `$fieldName ist ungültig ${
        additionalProps.pattern ? additionalProps.pattern : ''
      }`,
      dataRuleValueInvalidDate: 'Bitte geben Sie ein gültiges Datum ein',
      regExPatternNoMatch: '$fieldName ist ungültig',
      dataRuleNumeric: '$fieldName muss eine Zahl sein',
      paymentFormSecurityCodeInvalid:
        'Ungültige Prüfnummer für die gewählte Kartenart.',
      creditCardExpiredError: 'Die Kreditkarte ist abgelaufen',
      invalidEmail:
        'Entschuldigung, die E-Mail-Adresse sieht nicht richtig aus. Bitte überprüfen Sie die E-Mail und versuchen Sie es erneut.',
      // Field Names
      title: 'Titel',
      firstName: 'Vorname',
      lastName: 'Nachname',
      dateOfBirth: 'Geburtsdatum',
      country: 'Wohnsitz',
      emailAddress: 'E-Mail',
      password: 'Passwort',
      recieveLatestNews: '',
      confirmationTC: '',
      deviceName: 'Spitzname',
      nameOnCard: 'Name auf der Karte',
      securityCode: 'Prüfnummer',
      addressLineOne: 'Adresszeile 1',
      city: 'Ort',
      state: 'Bundesland',
      region: 'Region',
      province: 'Kreis',
      postalCode: 'PLZ',
      zipCode: 'PLZ',
      cardNumber: 'Kartennummer',
    },
    'nl-NL': {
      // Error Templates
      required: '$fieldName is vereist',
      invalid: '$fieldName is ongeldig',
      invalidFormat: `$fieldName is vereist ${
        additionalProps.format ? additionalProps.format : ''
      }`,
      maxLength: `$fieldName heeft een maximale lengte van ${
        additionalProps.maxLength ? additionalProps.maxLength : ''
      }`,
      minLength: `$fieldName does not meet minimum character length  ${
        additionalProps.minLength ? additionalProps.minLength : ''
      }`,
      minLengthName: `'$fieldName' vereist minimaal twee tekens`,
      patternName: `'$fieldName' bevat ongeldige tekens`,
      maxAge: `Voer een geboortedatum in dit formaat in: ${
        additionalProps.format ? additionalProps.format : ''
      }`,
      minAge: `Sorry, je moet ten minste ${
        additionalProps.minAge ? additionalProps.minAge : ''
      } zijn om een account aan te maken.`,
      pattern: `$fieldName kwam niet overeen met patroon ${
        additionalProps.pattern ? additionalProps.pattern : ''
      }`,
      dataRuleValueInvalidDate: 'Gelieve een correcte datum in te voeren',
      regExPatternNoMatch: '$fieldName kwam niet overeen met patroon',
      dataRuleNumeric: '$fieldName moet numeriek zijn',
      paymentFormSecurityCodeInvalid:
        'Ongeldige CVV voor het geselecteerde type kaart.',
      creditCardExpiredError: 'De creditcard is verlopen',
      invalidEmail:
        'Sorry, dat emailadres ziet er niet goed uit. Controleer de e-mail en probeer het opnieuw.',
      // Field Names
      title: 'Aanhef',
      firstName: 'Voornaam',
      lastName: 'Achternaam',
      dateOfBirth: 'Geboortedatum',
      country: 'Land',
      emailAddress: 'E-mailadres',
      password: 'Wachtwoord',
      recieveLatestNews: '',
      confirmationTC: '',
      deviceName: 'Bijnaam',
      nameOnCard: 'Naam op kaart',
      securityCode: 'Beveiligingscode',
      addressLineOne: 'Adresregel 1',
      city: 'Plaats',
      state: 'Land',
      region: 'Regio',
      province: 'Provincie',
      postalCode: 'Postcode',
      zipCode: 'Postcode',
      cardNumber: 'Kaartnummer',
    },
    'pt-BR': {
      // Error Templates
      required: '$fieldName é exigida',
      invalid: '$fieldName é inválida',
      invalidFormat: `$fieldName is in an invalid format ${
        additionalProps.format ? additionalProps.format : ''
      }`,
      maxLength: `$fieldName tem uma extensão máxima de ${
        additionalProps.maxLength ? additionalProps.maxLength : ''
      }`,
      minLength: `$fieldName does not meet minimum character length  ${
        additionalProps.minLength ? additionalProps.minLength : ''
      }`,
      patternName: `O '$fieldName' contém caracteres inválidos`,
      minLengthName: `O '$fieldName' requer um mínimo de dois caracteres`,
      maxAge: `Inserir uma data de nascimento neste formato: ${
        additionalProps.format ? additionalProps.format : ''
      }`,
      minAge: `Desculpe, mas você precisa ter ao menos ${
        additionalProps.minAge ? additionalProps.minAge : ''
      } anos de idade para registrar uma conta.`,
      pattern: `$fieldName não teve equivalência com o padrão ${
        additionalProps.pattern ? additionalProps.pattern : ''
      }`,
      dataRuleValueInvalidDate: 'Inserir uma data válida',
      regExPatternNoMatch: '$fieldName não teve equivalência com o padrão',
      dataRuleNumeric: '$fieldName deve ser numérico',
      paymentFormSecurityCodeInvalid:
        'CVV inválido para o tipo de cartão selecionado.',
      creditCardExpiredError: 'O cartão de crédito expirou',
      invalidEmail:
        'Desculpe, esse endereço de e-mail não me parece correcto. Por favor, verifique o e-mail e tente novamente.',
      // Field Names
      title: 'Título',
      firstName: 'Nome',
      lastName: 'Sobrenome',
      dateOfBirth: 'Data de nascimento',
      country: 'País de residência',
      emailAddress: 'E-mail',
      password: 'Senha',
      recieveLatestNews: '',
      confirmationTC: '',
      deviceName: 'Apelido',
      nameOnCard: 'Nome no cartão',
      securityCode: 'Código de segurança',
      addressLineOne: 'Linha de endereço 1',
      city: 'Cidade',
      state: 'Estado',
      region: 'Região',
      province: 'Província',
      postalCode: 'Código postal',
      zipCode: 'CEP',
      cardNumber: 'Número do cartão',
    },
  };
  const template = translations?.[locale]?.[error] || '';
  const fieldName = translations?.[locale]?.[field] || '';

  const message = template.replace('$fieldName', fieldName);
  return message;
};
